import defaultSplideCss from '@splidejs/splide/dist/css/splide.min.css';
import splideCss from '../css/splide.css';

// スタイルタグとして挿入
const style = document.createElement('style');
style.textContent = defaultSplideCss + splideCss;
document.head.appendChild(style);

// const style2 = document.createElement('style');
// style2.textContent = footerCss;
// document.head.appendChild(style2);